import { Avatar, AvatarContent, AvatarDescription, AvatarImage } from '@playbooks/ui/components/avatar';
import { Link } from '@playbooks/ui/components/link';
import { cn } from '@playbooks/ui/lib/utils';

export const CommentAvatar = ({ thumbnail, title, href, className = '' }) => {
	// Theme
	const rootClassName = cn('group h-auto p-0', className);

	// Render
	return (
		<Link variant='ghost' href={href} className={rootClassName}>
			<Avatar className='flex-start gap-3'>
				<AvatarImage size='xs' src={thumbnail} alt={title} />
				<AvatarContent>
					<AvatarDescription className='group-hover:underline'>{title}</AvatarDescription>
				</AvatarContent>
			</Avatar>
		</Link>
	);
};
